import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useReadOnly } from "@/contexts/ReadOnlyContext";

export const DeactivatedAccountBanner = () => {
  const { isDeactivated, accountType } = useReadOnly();

  if (!isDeactivated) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-4 border-orange-500/50 bg-orange-50 text-orange-900 dark:bg-orange-950 dark:text-orange-100">
      <AlertTriangle className="h-4 w-4 !text-orange-600" />
      <AlertTitle>Account Deactivated</AlertTitle>
      <AlertDescription>
        Your {accountType === 'portal' ? 'company' : 'partner'} account has been deactivated.
        You can view your data but cannot make changes.
        Contact <a href="mailto:support@pontis.life" className="underline font-medium">support@pontis.life</a> to reactivate.
      </AlertDescription>
    </Alert>
  );
};
